<template>
    <div class="page welcome-page">
        <!-- <e-section 
            img="vector.svg" 
            description="هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل توضع الفقرات في الصفحة التي يقرأها. ولذلك يتم استخدام طريقة لوريم إيبسوم لأنها تعطي توزيعاَ طبيعياَ -إلى حد ما- للأحرف عوضاً عن استخدام هنا يوجد محتوى نصي، هنا يوجد محتوى نصي فتجعلها تبدو (أي الأحرف) وكأنها نص مقروء. "
            :button1="{text: 'ابدأ بالربح اﻵن', icon: 'mdi-cash-multiple', to: {name: 'register'}}"
            :button2="{text: 'اعرف اكثر', icon: 'mdi-information-outline', to: {name: 'about'}}"
            
            :reverse="true"
        >
            <h1 class="headline" slot="headline">
                هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى
            </h1>
        </e-section>

        <e-section 
            img="vector2.svg" 
            description="هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل توضع الفقرات في الصفحة التي يقرأها. ولذلك يتم استخدام طريقة لوريم إيبسوم لأنها تعطي توزيعاَ طبيعياَ -إلى حد ما- للأحرف عوضاً عن استخدام هنا يوجد محتوى نصي، هنا يوجد محتوى نصي فتجعلها تبدو (أي الأحرف) وكأنها نص مقروء. "
            :button1="{text: 'ابدأ بالربح اﻵن', icon: 'mdi-cash-multiple', to: {name: 'register'}}"
            :button2="{text: 'اعرف اكثر', icon: 'mdi-information-outline', to: {name: 'about'}}"
            background="rgb(249, 249, 249)"
        >
            <h1 class="headline" slot="headline">هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى
            </h1>
        </e-section>

        <slot name="footer" /> -->
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import ESection from '@/components/default/layouts/e-section'
import ColsSection from '@/components/default/layouts/cols-section'
export default {
    name: "Welcome",
    data(){
        return {
            
        }
    },
    components: {
        ESection,
        ColsSection
    },
    computed: {
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    },
    created(){
        this.$router.push({name: 'login'});
    }
};
</script>
